import * as attendances from "@/services/attendances";

const attendance = {
  namespaced: true,
  state: () => ({
    presences: [],
    maxPagePresences: 1,
    totalResultPresences: "",
    currentPagePresences: 1,
    rowsPerPagePresences: 10,
    absents: [],
    maxPageAbsents: 1,
    totalResultAbsents: "",
    currentPageAbsents: 1,
    rowsPerPageAbsents: 10,
    reasonAbsents: [],
    absenDescriptions: [],
    locationOffices: [],
  }),
  getters: {
    presenceIdx(state) {
      return state.presences.map((item, index) => {
        return {
          ...item,
          idx:
            state.currentPagePresences === 1
              ? index + 1
              : (state.currentPagePresences - 1) * state.rowsPerPagePresences +
              index +
              1,
          userId: item.presenceUserId,
          employeeId: item.presenceUserEmployeeId,
          userName: item.presenceUserName,
          enterTime: item.presenceTimestampEnter,
          leaveTime:
            item.presenceTimestampLeave === null
              ? "-"
              : item.presenceTimestampLeave,
          enterLocation: item.presenceLocationEnter,
          leaveLocation: item.presenceLocationLeave,
          workingTime: item.workingHour,
          desc: item.workingDescription,
          status: item.workLocationStatus,
        };
      });
    },
    absentIdx(state) {
      return state.absents.map((item, index) => {
        return {
          ...item,
          idx:
            state.currentPageAbsents === 1
              ? index + 1
              : (state.currentPageAbsents - 1) * state.rowsPerPageAbsents +
              index +
              1,
          startDate: item.absentTimestampStart,
          endDate: item.absentTimestampEnd,
          employeeName: item.absentRequesterUserName,
          employeeNameId: item.absentRequesterUserEmployeeId,
          reason: item.absentReasonName,
          desc: item.absentDescription,
          statusId: item.absentStatusId,
          statusName: item.absentStatusName,
        };
      });
    },
    optionReason(state) {
      return state.reasonAbsents.map((item) => ({
        value: item.reasonId,
        label: item.reasonName,
      }));
    },
    optionAbsentDescription(state) {
      return state.absenDescriptions.map((item) => ({
        value: item.absentDescription,
        label: item.absentDescription,
      }));
    },
  },
  mutations: {
    setPresences(state, payload) {
      state.presences = payload.data;
      state.maxPagePresences = payload.maxPage;
      state.totalResultPresences = payload.totalResult;
    },
    setCurrentPagePresences(state, params) {
      state.currentPagePresences = params;
    },
    setRowsPerPagePresences(state, params) {
      state.rowsPerPagePresences = params;
    },
    setAbsents(state, payload) {
      state.absents = payload.data;
      state.maxPageAbsents = payload.maxPage;
      state.totalResultAbsents = payload.totalResult;
    },
    setCurrentPageAbsents(state, params) {
      state.currentPageAbsents = params;
    },
    setRowsPerPageAbsents(state, params) {
      state.rowsPerPageAbsents = params;
    },
    setReasonAbsents(state, response) {
      state.reasonAbsents = response.data;
    },
    setAbsentDescription(state, response) {
      state.absenDescriptions = response.data;
    },
    setLocationOffices(state, response) {
      state.locationOffices = response.data;
    },
  },
  actions: {
    async callGetListPresence(store, request) {
      try {
        const response = await attendances.indexPresence(request);
        store.commit("setPresences", response.data);
      } catch (error) {
        throw error;
      }
    },
    async callGetPresenceById(store, request) {
      try {
        const response = await attendances.indexPresenceById(request);
        store.commit("setPresences", response.data);
      } catch (error) {
        throw error;
      }
    },
    async callGetListAbsent(store, request) {
      try {
        // checking when delete data on page > 1 and no data on page
        if(request.page > 1 ){
          const response = await attendances.indexAbsent(request);
          if(response.data.data.length > 0){
            store.commit("setAbsents", response.data);
          }else{
            request.page = request.page - 1;
            console.log('ini', request)
            const response = await attendances.indexAbsent(request);
            store.commit("setAbsents", response.data);
          }
        }else{
          const response = await attendances.indexAbsent(request);
          store.commit("setAbsents", response.data);
        }
      } catch (error) {
        throw error;
      }
    },
    async callResponseAbsent(store, request) {
      try {
        await attendances.responseAbsent(request);
        return await store.dispatch("callGetListAbsent", {
          page: store.state.currentPageAbsents,
          row: store.state.rowsPerPageAbsents,
          statusIds: [1, 2, 3],
        });
      } catch (error) {
        throw error;
      }
    },
    async callResponseAbsentBatch(store, request) {
      try {
        await attendances.responseAbsentBatch(request);
        return await store.dispatch("callGetListAbsent", {
          page: store.state.currentPageAbsents,
          row: store.state.rowsPerPageAbsents,
          statusIds: [1, 2, 3],
        });
      } catch (error) {
        throw error;
      }
    },
    async enterPresence(store, request) {
      try {
        return await attendances.enterPresence(request);
      } catch (err) {
        throw err;
      }
    },
    async leavePresence(store, request) {
      try {
        return await attendances.leavePresence(request);
      } catch (err) {
        throw err;
      }
    },
    async getListReasons(store) {
      try {
        const response = await attendances.indexReason();
        store.commit("setReasonAbsents", response.data);
      } catch (err) {
        throw err;
      }
    },
    async requestAbsent(store, request) {
      try {
        return await attendances.requestAbsent(request);
      } catch (err) {
        throw err;
      }
    },
    async getAbsentDescription(store) {
      try {
        const response = await attendances.indexDescription();
        store.commit("setAbsentDescription", response.data);
      } catch (err) {
        throw err;
      }
    },
    async getLocationOffices(store) {
      try {
        const response = await attendances.indexLocation();
        store.commit("setLocationOffices", response.data);
      } catch (err) {
        throw err;
      }
    },
  },
};

export default attendance;
